import React from "react";
import { SingleCardPage } from "components/ui/SingleCardPage";
import { UserAuthsIndexCard } from "components/cards/UserAuths/UserAuthsIndexCard";
import { ErrorBoundary } from "components/ui/ErrorBoundary";
import { RequireSuperuser } from "components/auth/RequireSuperuser";

export function UserAuthsPage() {
  return (
    <RequireSuperuser>
      <SingleCardPage title="Users Auths" header="User Auths">
        <ErrorBoundary title="Users Auths">
          <UserAuthsIndexCard />
        </ErrorBoundary>
      </SingleCardPage>
    </RequireSuperuser>
  );
}
UserAuthsPage.displayName = "UserAuthsPage";
